<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="text-danger text-center">
        <strong>
          Are you sure you want to reject the file upload "{{ fileName }}"?<br/>
          Rejection notification will be sent to the carrier (WF).
        </strong>
      </div>
      <hr>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Close</button>
      <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-check-circle-o"></i> Reject File</button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Modal dialog allows to reject claim file upload.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.s
   * title   - form title.
   *
   * Usage examples:
   *
   * <reject-file-upload-modal modal-id="rejectFileModal"
   *                           title="Reject File Upload"
   *                           action="{{ route('uploads.reject', ['claim' => $claim, 'file' => $upload]) }}"
   *                           file-name="{{ $upload->name }}">
   *   <a class="btn btn-sm btn-danger" v-modal="'rejectFileModal'">
   *     <i class="fa fa-check-circle-o"></i> Reject
   *   </a>
   * </approve-file-upload-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id
    modalId: {
      required: false,
      type: String,
      default: 'rejectFileModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    fileName: {
      type: String,
      default: ""
    },

  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  },
}
</script>
